import config from 'config';

class GoogleAnalytics {
  default () {
    window.dataLayer.push({ 'vsGoogleAnalyticsId': config.Analytics.googleID });
    window.dataLayer.push({ 'vsGoogleAnalyticsDomain': config.Analytics.domain });
  }

  vsSales(campaign, product, coupon) {
    let productPayload = {
      id: `${product.product.id}`,
      name: `${product.product.sku}`,
      variant: `${product.product_color.name}`,
      price: `${product.selling_price}`
    };

    if (coupon) productPayload.coupon = `${coupon}`;

    window.dataLayer.push({ 'vsGoogleAnalyticsId': config.Analytics.googleID });
    window.dataLayer.push({ 'vsGoogleAnalyticsDomain': config.Analytics.domain });
    window.dataLayer.push({ 'vsGoogleAnalyticsCampaignId': `${campaign.id}` });
    window.dataLayer.push({ 'vsGoogleAnalyticsCreatorId': `${campaign.creator.id}` });
    window.dataLayer.push({ 'vsGoogleAnalyticsProductPayload': productPayload });

    window.dataLayer.push({ 'event': 'vs-google-analytics-sales-tracking' });
  }

  clientSales(campaign) {
    if (campaign.creator.user_info.google_analytics_code) {
      window.dataLayer.push({ 'clientGoogleAnalyticsId': campaign.creator.user_info.google_analytics_code });

      window.dataLayer.push({ 'event': 'client-google-analytics-tracking' });
    }
  }

  vsThankYou(order) {
    let coupon = (order.campaign_upsell != null) ? 'upsell' : order.coupon.code,
      products = order.order_products,
      productsPayload = [],
      purchasePayload = this._purchasePayload(order);

    if (coupon) purchasePayload['coupon'] = coupon;

    for (var i = 0; i < products.length; i++) {
      let cp = products[i].campaign_product;
      let product = {
        id: `${cp.product.id}`,
        name: `${cp.product.sku}`,
        variant: `${cp.product_color.name}`,
        price: `${cp.selling_price + cp.product.upcharges[products[i].size]}`,
        quantity: `${products[i].quantity}`,
        'dimension7': `${products[i].size}`
      };
      if (coupon) product['coupon'] = coupon;
      productsPayload.push(product);
    }

    window.dataLayer.push({ 'vsGoogleAnalyticsId': config.Analytics.googleID });
    window.dataLayer.push({ 'vsGoogleAnalyticsDomain': config.Analytics.domain });
    window.dataLayer.push({ 'vsGoogleAnalyticsPaymentType': order.transaction.payment_type });
    window.dataLayer.push({ 'vsGoogleAnalyticsCurrency': order.transaction.currency });
    window.dataLayer.push({ 'vsGoogleAnalyticsProductsPayload': productsPayload });
    window.dataLayer.push({ 'vsGoogleAnalyticsPurchasePayload': purchasePayload });

    window.dataLayer.push({ 'event': 'vs-google-analytics-thank-you-tracking' });
  }

  clientThankYou(order, upsellOrder) {
    if (order && order.campaign.creator.user_info.google_analytics_code) {
      let clientGoogleAnalyticsPayload = this._purchasePayload(order);

      window.dataLayer.push({ 'clientGoogleAnalyticsPayload': clientGoogleAnalyticsPayload });
      window.dataLayer.push({ 'clientGoogleAnalyticsId': order.campaign.creator.user_info.google_analytics_code });

      window.dataLayer.push({ 'event': 'client-google-analytics-tracking' });
      window.dataLayer.push({ 'event': 'client-google-analytics-thank-you-tracking' });
    }

    if (upsellOrder && upsellOrder.campaign.creator.user_info.google_analytics_code) {
      let clientGoogleAnalyticsUpsellPayload = this._purchasePayload(upsellOrder);

      window.dataLayer.push({ 'clientGoogleAnalyticsUpsellPayload': clientGoogleAnalyticsUpsellPayload });
      window.dataLayer.push({ 'clientGoogleAnalyticsId': upsellOrder.campaign.creator.user_info.google_analytics_code });

      window.dataLayer.push({ 'event': 'client-google-analytics-thank-you-upsell-tracking' });
    }
  }

  clientStore(store) {
    if (store.google_analytics) {
      window.dataLayer.push({ 'clientGoogleAnalyticsId': store.google_analytics });

      window.dataLayer.push({ 'event': 'client-google-analytics-tracking' });
    }
  }

  addToCart(product, quantity, size) {
    product.size = size;
    let productPayload = this._productPayload(product);
    productPayload.quantity = quantity;
    productPayload['dimension7'] = size;

    window.dataLayer.push({ 'vsGoogleAnalyticsAddToCartPayload': productPayload });
  }

  removeFromCart(product, quantity, size) {
    product.size = size;
    let productPayload = this._productPayload(product);
    productPayload.quantity = quantity;
    productPayload['dimension7'] = size;

    window.dataLayer.push({ 'vsGoogleAnalyticsRemoveFromCartPayload': productPayload });
  }

  changeSize(size) {
    window.dataLayer.push({ 'vsGoogleAnalyticsSize': size });
  }

  changeQuantity(quantity) {
    window.dataLayer.push({ 'vsGoogleAnalyticsQuantity': quantity });
  }

  changeColor(color) {
    window.dataLayer.push({ 'vsGoogleAnalyticsColor': color });
  }

  applyCoupon(coupon) {
    window.dataLayer.push({ 'vsGoogleAnalyticsCoupon': coupon });
  }

  checkout(cart, isUpsell, option) {
    this._checkout(cart, isUpsell, option);
  }

  placeOrder(cart, isUpsell, option) {
    this._checkout(cart, isUpsell, option, 2);
  }

  register() {
    window.dataLayer.push({ 'vsGoogleAnalyticsId': config.Analytics.googleID });
    window.dataLayer.push({ 'vsGoogleAnalyticsDomain': config.Analytics.domain });
  }

  _productPayload(product) {
    return {
      'id': `${product.product.id}`,
      'name': `${product.product.sku}`,
      'variant': `${product.product_color.name}`,
      'price': `${product.selling_price + product.product.upcharges[product.size]}`
    }
  }

  _checkout(cart, isUpsell = false, option, step = 1) {
    if (!isUpsell) {
      let productsPayload = [];

      for (var i = 0; i < cart.length; i++) {
        let productPayload = this._productPayload(cart[i])
        productPayload.quantity = cart[i].qty;
        productPayload['dimension7'] = cart[i].size;
        productsPayload.push(productPayload);
      }

      window.dataLayer.push({ 'vsGoogleAnalyticsCheckoutProductsPayload': productsPayload });
    } else {
      window.dataLayer.push({ 'vsGoogleAnalyticsId': config.Analytics.googleID });
      window.dataLayer.push({ 'vsGoogleAnalyticsDomain': config.Analytics.domain });
    }

    let checkoutPayload = { step: step };
    if (option) checkoutPayload.option = option;

    if (step === 1) {
      window.dataLayer.push({ 'vsGoogleAnalyticsCheckoutStep1Payload': checkoutPayload });
    } else {
      window.dataLayer.push({ 'vsGoogleAnalyticsCheckoutStep2Payload': checkoutPayload });
    }
  }

  _purchasePayload(order) {
    let shipping = order.price.shipping_cost - order.price.shipping_discount;

    if (shipping < 0) shipping = 0;

    return {
      id: `${order.order_num}`,
      affiliation: `${order.campaign_id}`,
      revenue: `${(order.price.sub_total - order.price.coupon_discount).toFixed(2)}`,
      shipping: `${shipping.toFixed(2)}`,
      tax: `${order.price.sales_tax.toFixed(2)}`
    }
  }
}

export default new GoogleAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/google-analytics.js